module.exports = __webpack_public_path__ + "img/swift.da81c9c9.svg";